import React from 'react';
import Compass from '../../Compass/Desktop';
import './AwosHeaderDesktop.css';

function AwosHeaderDesktop(props) {
  return (
    <div className="awos-desktop-header">
      <div className="airport-identifier">
        <div className="airport-id">{props.airport.id}</div>
        <h1 className="airport-name">{props.airport.name}</h1>
      </div>
      <div className="airport-wind">
        <Compass wind={props.wind.direction}
                 speed={props.wind.speed}
                 gust={props.wind.gust} />
      </div>
    </div>
  );
}

export default AwosHeaderDesktop;


/** WEBPACK FOOTER **
 ** ./src/AwosHeader/Desktop/AwosHeaderDesktop.js
 **/